import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import CustomerGroupsGql from '@/extensions/shop/store/graphql/queries/CustomerGroups.gql';
import CustomerGroupsPaginatedGql from '@/extensions/shop/store/graphql/queries/CustomerGroupsPaginated.gql';
import SaveCustomerGroupGql from '@/extensions/shop/store/graphql/mutations/SaveCustomerGroup.gql';
import DeleteCustomerGroupGql from '@/extensions/shop/store/graphql/mutations/DeleteCustomerGroup.gql';

export default {
    fetchAll: (variables = {}) =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: CustomerGroupsGql,
                    variables,
                    fetchPolicy: 'no-cache',
                })
                .then(({ data }) => resolve(data.CO_CustomerGroups))
                .catch((err) => reject(err));
        }),
    fetchCustomerGroupsPaginated: (data) =>
        new Promise((resolve, reject) => {
            const filters = [];
            _.each(data.filters, (entry) => filters.push(entry));

            apolloClient
                .query({
                    query: CustomerGroupsPaginatedGql,
                    variables: {
                        scope: _.get(data, 'scope', 'ex'),
                        type: _.get(data, 'type', 'shop_customer_group'),
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', ''),
                        direction: _.get(data, 'variables.direction', ''),
                        filters,
                    },
                    fetchPolicy: 'no-cache',
                })
                .then(({ data }) => resolve(data.CO_CustomerGroupsPaginated))
                .catch((err) => reject(err));
        }),
    save: (group) => {
        if (group === undefined) throw new Error('required argument is missing');

        const payload = _.removeDeepByKey(_.cloneDeep(group), '__typename');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SaveCustomerGroupGql,
                    variables: { group: payload },
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_SaveCustomerGroup);
                })
                .catch((err) => reject(err));
        });
    },
    delete: (id) => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteCustomerGroupGql,
                    variables: { id: parseInt(id) },
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_DeleteCustomerGroup);
                })
                .catch((err) => reject(err));
        });
    },
};
